/* Complete-set: one matching case or glass, added with the main product. */
(function () {
  if (window.AiooCompleteSet) return;

  var root = document.querySelector('[data-aioo-complete-set]');
  if (!root) return;

  var cfgEl = document.getElementById('AiooCompleteSetConfig');
  var cfg = {};
  try {
    cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}');
  } catch (e) {
    cfg = {};
  }

  var labels = cfg.labels || {};
  var discountPct = parseInt(cfg.discountPct, 10) || 0;
  var selected = {};

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + n;
  }

  function prettyModel(raw) {
    var s = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    s = s.toLowerCase().replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
    return s.replace(/\bIphone\b/g, 'iPhone')
      .replace(/\bIpad\b/g, 'iPad')
      .replace(/\bSe\b/g, 'SE');
  }

  function parseModel(text) {
    var s = String(text || '');
    var ip = s.match(/iPhone\s+(?:SE(?:\s*\((?:2020|2022)\))?|\d{1,2}(?:\s+(?:Pro\s+Max|Pro|Plus|mini))?)/i);
    if (ip) return ip[0].replace(/\s+/g, ' ').trim();
    var gx = s.match(/Galaxy\s+[A-Z]?\d+\s*(?:Ultra|Plus|FE|\+|Edge)?/i);
    if (gx) return gx[0].replace(/\s+/g, ' ').trim();
    return '';
  }

  function handleOf(model) {
    return String(model || '')
      .toLowerCase()
      .replace(/[()]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function glassHub(model) {
    var m = String(model || '').toLowerCase();
    if (m.indexOf('iphone') !== -1 || m.indexOf('ipad') !== -1) return 'iphone-screen-protectors';
    if (m.indexOf('galaxy') !== -1 || m.indexOf('samsung') !== -1) return 'samsung-screen-protectors';
    if (/xiaomi|redmi|poco/.test(m)) return 'xiaomi-screen-protectors';
    if (m.indexOf('huawei') !== -1 || m.indexOf('honor') !== -1) return 'huawei-screen-protectors';
    return 'screen-protectors';
  }

  function kindOf(item) {
    var blob = ((item.product_type || '') + ' ' + (item.title || '') + ' ' + (item.handle || '')).toLowerCase();
    if (/aizsargstikl|screen-protector|screen protector|защитн/.test(blob) || /stikl/.test(blob)) return 'glass';
    if (/vāciņ|vacin|vakin|maciņ|macin|чехол|case/.test(blob) && blob.indexOf('airpod') === -1) return 'case';
    if (/telefons|smartphone|смартфон/.test(blob)) return 'phone';
    return 'other';
  }

  function blobOf(item) {
    return ((item.title || '') + ' ' + (item.type || '') + ' ' + (item.subtype || '') + ' ' + (item.handle || '')).toLowerCase();
  }

  function isCameraGlass(blob) {
    return /kamer|camera|camslider|\blens\b/.test(blob);
  }

  function isWatchGlass(blob) {
    return /pulksten|\bwatch\b|siksn/.test(blob);
  }

  function isPrivacyGlass(blob) {
    return /privacy|privāt|privat/.test(blob);
  }

  function isFilm(blob) {
    return /aizsargpl|plēv|plev|hydrogel/.test(blob);
  }

  /* In-stock screen glass only: not camera, watch, privacy, or film. */
  function isRegularScreenGlass(item) {
    var blob = blobOf(item);
    if (isCameraGlass(blob) || isWatchGlass(blob) || isPrivacyGlass(blob) || isFilm(blob)) return false;
    return /aizsargstikl|stikl|screen protector|glass/.test(blob);
  }

  function fetchList(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return [];
        return r.json();
      })
      .then(function (data) {
        var list = data && data.products;
        return list && list.length ? list : [];
      })
      .catch(function () { return []; });
  }

  function cheapestRegularGlass(list, skipHandle) {
    var best = null;
    (list || []).forEach(function (item) {
      if (!item || !item.id || !(item.price > 0)) return;
      if (skipHandle && item.handle === skipHandle) return;
      if (!isRegularScreenGlass(item)) return;
      if (!best || item.price < best.price) best = item;
    });
    return best;
  }

  function firstInStock(list, skipHandle) {
    var items = list || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || !item.id || !(item.price > 0)) continue;
      if (skipHandle && item.handle === skipHandle) continue;
      return item;
    }
    return null;
  }

  function glassUrl(handle, model) {
    var q = encodeURIComponent(String(model || '').toLowerCase());
    return '/collections/' + handle
      + '?filter.v.m.custom.compatible_model=' + q
      + '&filter.v.availability=1&sort_by=price-ascending&view=aioo-offer';
  }

  /* Gets-collections of the live "Komplekts" glass discount. */
  function glassGetsDiscount(handle) {
    return handle === 'screen-protectors' || handle === 'iphone-screen-protectors';
  }

  function markGlass(item, collectionHandle) {
    if (!item) return null;
    item.discountGets = glassGetsDiscount(collectionHandle);
    return item;
  }

  function fetchGlass(model, skipHandle) {
    return fetchList(glassUrl('screen-protectors', model)).then(function (list) {
      var pick = cheapestRegularGlass(list, skipHandle);
      if (pick) return markGlass(pick, 'screen-protectors');
      var hub = glassHub(model);
      if (hub === 'screen-protectors') return null;
      return fetchList(glassUrl(hub, model)).then(function (fallback) {
        return markGlass(cheapestRegularGlass(fallback, skipHandle), hub);
      });
    });
  }

  /* Shopify percentage discounts round the discount amount, then subtract it. */
  function discountedCents(cents) {
    var off = Math.round(cents * discountPct / 100);
    if (off < 0) off = 0;
    if (off > cents) off = cents;
    return cents - off;
  }

  function showGlassDiscount(item) {
    if (discountPct <= 0 || !item || !item.discountGets) return false;
    if (cfg.discountEligible === false) return false;
    return true;
  }

  function fetchCase(model, skipHandle) {
    var h = handleOf(model);
    return fetchList('/collections/' + h + '-cases?filter.v.availability=1&view=aioo-offer').then(function (list) {
      var pick = firstInStock(list, skipHandle);
      if (pick) return pick;
      return fetchList('/collections/apple-' + h + '-cases?filter.v.availability=1&view=aioo-offer').then(function (fallback) {
        return firstInStock(fallback, skipHandle);
      });
    });
  }

  function rowHtml(opts) {
    var price = opts.price;
    var note = opts.note || '';
    if (opts.discount && discountPct > 0) {
      price = discountedCents(opts.price);
      note = labels.discount || note;
    }
    var img = opts.image
      ? '<img class="aioo-set__photo" src="' + opts.image + '" alt="" width="48" height="48">'
      : '<span class="aioo-set__photo aioo-set__photo--empty" aria-hidden="true"></span>';
    if (opts.mode === 'button') {
      return '<li><div class="aioo-set__row" data-offer-id="' + opts.id + '">' +
        img +
        '<span class="aioo-set__copy"><span class="aioo-set__title">' + opts.title + '</span>' +
        (note ? '<span class="aioo-set__note">' + note + '</span>' : '') +
        '</span><span class="aioo-set__price">+' + money(price) + '</span>' +
        '<button type="button" class="aioo-set__add" data-add-id="' + opts.id + '" data-add-qty="' + (opts.qty || 1) + '"' + (opts.spare ? ' data-add-spare="1"' : '') + '>' +
        (labels.add || 'Pievienot') + '</button></div></li>';
    }
    return '<li><label class="aioo-set__row">' +
      '<input class="aioo-set__check" type="checkbox" data-set-id="' + opts.id + '" data-set-qty="' + (opts.qty || 1) + '" data-set-key="' + opts.key + '">' +
      '<span class="aioo-set__box" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      img +
      '<span class="aioo-set__copy"><span class="aioo-set__title">' + opts.title + '</span>' +
      (note ? '<span class="aioo-set__note">' + note + '</span>' : '') +
      '</span><span class="aioo-set__price">+' + money(price) + '</span></label></li>';
  }

  function mount(html, kevlarHref) {
    if (!html && !kevlarHref) return;
    var heading = document.createElement('p');
    heading.className = 'aioo-set__heading';
    heading.textContent = labels.heading || '';
    var list = document.createElement('ul');
    list.className = 'aioo-set__list';
    list.innerHTML = html;
    root.innerHTML = '';
    if (html) {
      root.appendChild(heading);
      root.appendChild(list);
    }
    if (kevlarHref && labels.kevlar) {
      var a = document.createElement('a');
      a.className = 'aioo-set__kevlar';
      a.href = kevlarHref;
      a.textContent = labels.kevlar;
      root.appendChild(a);
    }
    root.hidden = false;
    list.addEventListener('change', function (ev) {
      var input = ev.target;
      if (!input || !input.getAttribute('data-set-id')) return;
      var row = input.closest('.aioo-set__row');
      if (row) row.classList.toggle('is-on', input.checked);
      if (input.checked) selected[input.getAttribute('data-set-key')] = {
        id: parseInt(input.getAttribute('data-set-id'), 10),
        quantity: parseInt(input.getAttribute('data-set-qty'), 10) || 1
      };
      else delete selected[input.getAttribute('data-set-key')];
    });
  }

  function kevlarLink() {
    if (!cfg.kevlarHref || cfg.isKevlar) return '';
    if ((cfg.price || 0) >= 2200) return '';
    if (cfg.role !== 'case') return '';
    return cfg.kevlarHref;
  }

  function resolveModel() {
    if (cfg.modelExact && cfg.model) return cfg.model;
    return parseModel(cfg.model) || cfg.model || '';
  }

  function loadPdp() {
    var model = resolveModel();
    var jobs = [];
    if (cfg.role === 'case' && model) {
      jobs.push(fetchGlass(model, cfg.handle).then(function (p) {
        if (!p || p.handle === cfg.handle) return '';
        return rowHtml({
          key: 'glass',
          id: p.id,
          title: (labels.glass || '').replace('__MODEL__', prettyModel(model)),
          note: '',
          price: p.price,
          image: p.image,
          discount: showGlassDiscount(p)
        });
      }));
    } else if (cfg.role === 'phone' && model) {
      jobs.push(fetchCase(model, cfg.handle).then(function (p) {
        if (!p || p.handle === cfg.handle) return '';
        return rowHtml({
          key: 'case',
          id: p.id,
          title: (labels.case || '').replace('__MODEL__', prettyModel(model)),
          price: p.price,
          image: p.image,
          discount: false
        });
      }));
      jobs.push(fetchGlass(model, cfg.handle).then(function (p) {
        if (!p || p.handle === cfg.handle) return '';
        return rowHtml({
          key: 'glass',
          id: p.id,
          title: (labels.glass || '').replace('__MODEL__', prettyModel(model)),
          price: p.price,
          image: p.image,
          discount: showGlassDiscount(p)
        });
      }));
    } else if (cfg.role === 'glass' && cfg.variantId) {
      jobs.push(Promise.resolve(rowHtml({
        key: 'spare',
        id: cfg.variantId,
        qty: 1,
        title: labels.spare || '',
        note: labels.spareNote || '',
        price: cfg.price || 0,
        image: cfg.image || '',
        discount: false
      })));
    }
    Promise.all(jobs).then(function (parts) {
      mount(parts.filter(Boolean).join(''), kevlarLink());
    });
  }

  function loadCart() {
    var cartIds = {};
    function seenVariant(id) {
      return !!cartIds[String(id)];
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hasCase = false;
        var hasGlass = false;
        var hasPhone = false;
        var model = '';
        var glassLine = null;
        items.forEach(function (item) {
          if (item && item.variant_id) cartIds[String(item.variant_id)] = true;
          var k = kindOf(item);
          if (k === 'case') hasCase = true;
          if (k === 'glass') {
            hasGlass = true;
            glassLine = item;
          }
          if (k === 'phone') hasPhone = true;
          if (!model && (k === 'phone' || k === 'case' || k === 'glass')) {
            model = parseModel(item.product_title || item.title || '');
          }
        });
        var jobs = [];
        if (model && !hasGlass && (hasCase || hasPhone)) {
          jobs.push(fetchGlass(model).then(function (p) {
            if (!p || seenVariant(p.id)) return '';
            return rowHtml({
              mode: 'button',
              id: p.id,
              title: (labels.glass || '').replace('__MODEL__', prettyModel(model)),
              price: p.price,
              image: p.image,
              discount: showGlassDiscount(p)
            });
          }));
        }
        if (model && !hasCase && (hasPhone || hasGlass)) {
          jobs.push(fetchCase(model).then(function (p) {
            if (!p || seenVariant(p.id)) return '';
            return rowHtml({
              mode: 'button',
              id: p.id,
              title: (labels.case || '').replace('__MODEL__', prettyModel(model)),
              price: p.price,
              image: p.image,
              discount: false
            });
          }));
        }
        if (hasGlass && glassLine && glassLine.quantity === 1) {
          jobs.push(Promise.resolve(rowHtml({
            mode: 'button',
            id: glassLine.variant_id,
            qty: 1,
            spare: true,
            title: labels.spare || '',
            note: labels.spareNote || '',
            price: glassLine.original_price || glassLine.price,
            image: glassLine.image,
            discount: false
          })));
        }
        return Promise.all(jobs);
      })
      .then(function (parts) {
        if (!parts) return;
        mount(parts.filter(Boolean).join(''), '');
        root.addEventListener('click', function (ev) {
          var btn = ev.target.closest('[data-add-id]');
          if (!btn || btn.disabled) return;
          btn.disabled = true;
          var id = parseInt(btn.getAttribute('data-add-id'), 10);
          var qty = parseInt(btn.getAttribute('data-add-qty'), 10) || 1;
          var spareAdd = btn.getAttribute('data-add-spare') === '1';
          if (!spareAdd && cartIds[String(id)]) {
            btn.disabled = false;
            return;
          }
          if (!spareAdd) cartIds[String(id)] = true;
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add');
            window.location.reload();
          }).catch(function () {
            btn.disabled = false;
          });
        });
      })
      .catch(function () {});
  }

  window.AiooCompleteSet = {
    itemsForAdd: function (mainId, mainQty) {
      var extras = [];
      var spare = false;
      var seenExtra = {};
      Object.keys(selected).forEach(function (key) {
        var row = selected[key];
        if (!row || !row.id) return;
        if (key === 'spare') {
          spare = true;
          return;
        }
        var eid = String(row.id);
        if (eid === String(mainId) || seenExtra[eid]) return;
        seenExtra[eid] = true;
        extras.push({ id: row.id, quantity: row.quantity || 1 });
      });
      if (!extras.length && !spare) return null;
      var items = [{ id: parseInt(mainId, 10), quantity: (mainQty || 1) + (spare ? 1 : 0) }];
      return items.concat(extras);
    }
  };

  if (cfg.context === 'cart') loadCart();
  else loadPdp();
})();
